module.exports = __webpack_public_path__ + "img/8.cf9c3448.png";